export default function isTerminated(data) {
	return data.termination?.status === true;
}
